export default __webpack_public_path__ + "static/media/right-signUnCheck.84001d96.svg";